import { Injectable } from 'angular-ts-decorators';
import { RouteStreams } from '@shared/app/scripts/services/route-streams';
import { Intercom } from '@shared/app/scripts/services/intercom';

/**
 * Service that manages the changes that must be done
 * if the page has been loaded in an iFrame
 */
@Injectable('iframeManager')
export class IframeManager {
  private activeClasses: Set<string> = new Set();

  constructor(
    private routeStreams: RouteStreams,
    private $document: ng.IDocumentService,
    private $window: ng.IWindowService,
    private intercom: Intercom,
  ) {
    'ngInject';
    // Subscribe to route changes
    this.routeStreams.changeSuccess$.subscribe(() => {
      this.updateStyles();
    });
  }

  /**
   * Handle the changes that must be done for an Iframe
   */
  handleIFrame(): void {
    const isInIframe = this.$window.self !== this.$window.top;
    const htmlElement = this.$document[0]?.documentElement || this.$document[0];
    if (isInIframe) {
      // Add the classes that makes the style suites the iFrame and qliqpoint
      this.activeClasses.add('iframe-mode');
      if (htmlElement) {
        htmlElement.classList.add('html-iframe-mode');
      }

      // Disable and hide the intercom
      this.intercom.disable();
    }
    this.updateStyles();
  }

  private updateStyles(): void {
    const body = this.$document[0]?.body;

    if (!body) {
      return;
    }

    // Get current classes on the body
    const currentClasses = Array.from(body.classList);

    // Remove classes that are no longer in activeClasses
    currentClasses.forEach((className) => {
      if (!this.activeClasses.has(className)) {
        body.classList.remove(className);
      }
    });

    // Add only new classes that aren't already present
    this.activeClasses.forEach((className) => {
      if (!body.classList.contains(className)) {
        body.classList.add(className);
      }
    });
  }
}
